import { render, staticRenderFns } from "./ChapterCard.vue?vue&type=template&id=c559fb8c&scoped=true&"
import script from "./ChapterCard.vue?vue&type=script&lang=js&"
export * from "./ChapterCard.vue?vue&type=script&lang=js&"
import style0 from "./ChapterCard.vue?vue&type=style&index=0&id=c559fb8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c559fb8c",
  null
  
)

export default component.exports